import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Projects from "@/pages/Projects";
import { api } from "@/lib/api";
import { DEFAULT_RATES } from "@/lib/currency";
import "@/App.css";

export const CurrencyContext = { current: { code: "GBP", rates: DEFAULT_RATES } };

function App() {
  const [currency, setCurrency] = useState("GBP");
  const [rates, setRates] = useState(DEFAULT_RATES);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/geo")
      .then((res) => {
        if (cancelled) return;
        if (res.data?.rates) setRates(res.data.rates);
        if (res.data?.currency && DEFAULT_RATES[res.data.currency]) setCurrency(res.data.currency);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#FAF9F6] text-[#1C211E]">
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<Landing currency={currency} setCurrency={setCurrency} rates={rates} />}
          />
          <Route
            path="/projects"
            element={<Projects currency={currency} setCurrency={setCurrency} rates={rates} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
